/* eslint-disable no-unused-vars */
import React, { FC, useState, useRef, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Space, Card, Row, Col, DatePicker, Radio } from 'antd'
import PageBreadcrumb from '@/components/pageBreadcrumb'
// 引入 echarts 核心模块
import * as echarts from 'echarts/core'
import {
    LegendComponent,
    GridComponent,
    TooltipComponent,
    TitleComponent,
    DataZoomComponent,
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
// 按需引入图表类型
import { BarChart, LineChart, PieChart } from 'echarts/charts'
import Nav from '@/components/nav'
import {
    barChartOption,
    EChartsOption,
    pieChartOption,
    stackedBarChartOption,
} from '@/helpers/proposalChart'
import { cloneDeep } from 'lodash'
// import ProposalTable from './rag/components/proposalTable'
import {
    EAPI_TYPE,
    ESTACKED_CHART_TYPE,
    getChart3DataApi,
    getChart45DataApi,
    getChart678DataApi,
    getChartDataApi,
} from '@/services/progress.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import moment from 'moment'
import type { EventValue, RangeValue } from 'rc-picker/lib/interface'
import type { Moment } from 'moment'
import './index.less'

echarts.use([
    BarChart,
    LineChart,
    PieChart,
    CanvasRenderer,
    LegendComponent,
    GridComponent,
    TooltipComponent,
    TitleComponent,
    DataZoomComponent,
])

enum EREVIEW_TYPE {
  TAB1 = 1,
  TAB2 = 2,
  TAB3 = 4,
  TAB4 = 3,
}

const subtractMonths =  moment().subtract(6, 'month')
const DATE_FORMAT = 'YYYY-MM-DD'

const ProposalBoard: FC = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { RangePicker } = DatePicker
    const { t } = useTranslation()
    // 图表实例引用
    const chartRef1 = useRef<any>(null)
    const chartInstance1 = useRef<any>(null)
    const chartRef2 = useRef<any>(null)
    const chartInstance2 = useRef<any>(null)
    const chartRef3 = useRef<any>(null)
    const chartInstance3 = useRef<any>(null)
    const chartRef4 = useRef<any>(null)
    const chartInstance4 = useRef<any>(null)
    const chartRef5 = useRef<any>(null)
    const chartInstance5 = useRef<any>(null)
    const chartRef6 = useRef<any>(null)
    const chartInstance6 = useRef<any>(null)
    const chartRef7 = useRef<any>(null)
    const chartInstance7 = useRef<any>(null)
    const chartRef8 = useRef<any>(null)
    const chartInstance8 = useRef<any>(null)
    const momentObj = moment()
    const [dateRangeArr, setDateRangeArr] = useState<
    [EventValue<Moment>, EventValue<Moment>][]
  >([
      [subtractMonths, momentObj],
      [subtractMonths, momentObj],
      [subtractMonths, momentObj],
      [subtractMonths, momentObj],
      [subtractMonths, momentObj],
      [subtractMonths, momentObj],
      [subtractMonths, momentObj],
      [subtractMonths, momentObj]
  ])


    const [winW, setWinW] = useState(0)
    const [routes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/proposalBoard',
            breadcrumbName: t('proposal board'),
        },
    ])

    const [aspectRatio, setAspectRatio] = useState<'1:1' | '16:9' | '4:3'>('1:1')
    
    // 计算图表高度
    const getChartStyle = (isLarge: boolean) => {
        // 根据比例计算高度
        if(aspectRatio === '1:1'){
            return {
                width: '100%',
                height: isLarge ? 500 : 300
            }
        }
        const ratio = aspectRatio === '16:9' ? 16 / 9 : 4 / 3
        const height = isLarge ? 500 : 300
        const width = height * ratio
        return {
            width:width,
            height: height
        }
    }

    useEffect(() => {
        setWinW(document.body.clientWidth)
        window.onresize = () => {
            setWinW(document.body.clientWidth)
        }
        return () => {
            window.onresize = null
        }
    }, [])

    useEffect(() => {
        // 窗口大小变化时重新初始化所有图表
        chartInstance1.current?.resize()
        chartInstance2.current?.resize()
        chartInstance3.current?.resize()
        chartInstance4.current?.resize()
        chartInstance5.current?.resize()
        chartInstance6.current?.resize()
        chartInstance7.current?.resize()
        chartInstance8.current?.resize()
    }, [winW, aspectRatio]) // 添加aspectRatio作为依赖

    // 合并后的通用初始化函数
    const initCharts = (
        chartRef: React.RefObject<any>,
        chartInstanceRef: React.MutableRefObject<any>,
        data: EChartsOption
    ): void => {
        const chart = chartRef.current
        if (!chart) return

        let chartInstance = chartInstanceRef.current
        if (chartInstance) {
            chartInstance.clear()
        }
        chartInstanceRef.current = echarts.init(chart)
        chartInstance = chartInstanceRef.current
        if (!data) {
            data = stackedBarChartOption
        }
        const options = cloneDeep(data)
        chartInstance.setOption(options)
    }
    //  图表数据处理
    const getSeriesData = (
        yAxis: string[],
        keyMap: {
      [key: string]: string;
    },
        Data: { [key: string]: number[] }
    ) => {
        const series = []
        for (const i of yAxis) {
            series.push({
                name: keyMap[i],
                type: 'bar',
                stack: 'Ad',
                emphasis: {
                    focus: 'series',
                },
                data: Data[i],
            })
        }
        return series
    }

    // 获取数据
    const getChartData = async (type: EAPI_TYPE) => {
        let params = {
            startTime: '',
            endTime: '',
            isPlReview: null,
            name: '',
            reviewType: EREVIEW_TYPE.TAB3,
            type,
        }
        switch(type){
            case EAPI_TYPE.LEAD :{
                const [startTime,endTime] = dateRangeArr[0]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                }
                break
            }
      
            case EAPI_TYPE.TECH_TYPE:{
                const [startTime,endTime] = dateRangeArr[1]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                }
                break
            }

        }
        const res = await getChartDataApi(params)
        const cloneOption: any = cloneDeep(stackedBarChartOption)
        switch (type) {
            case EAPI_TYPE.LEAD: {
                const yAxis: string[] = [
                    'runningOrBase',
                    'leadingOrCore',
                    'advancedOrKey',
                ]
                const keyMap: {
                    [key: string]: string;
                    } = {
                        runningOrBase: '追赶',
                        leadingOrCore: '领先',
                        advancedOrKey: '持平',
                    }
                cloneOption.xAxis[0].data = res.workGroupName
                cloneOption.series = getSeriesData(yAxis, keyMap, res)
                console.log(cloneOption,'123312')
                initCharts(chartRef1, chartInstance1, cloneOption)
                break
            }
            case EAPI_TYPE.TECH_TYPE: {
                const yAxis: string[] = [
                    'runningOrBase',
                    'leadingOrCore',
                    'advancedOrKey',
                    'reserve',
                ]
                const keyMap: {
          [key: string]: string;
        } = {
            runningOrBase: '基础技术',
            leadingOrCore: '核心技术',
            advancedOrKey: '关键技术',
            reserve: '储备技术',
        }
                cloneOption.xAxis[0].data = res.workGroupName
                cloneOption.series = getSeriesData(yAxis, keyMap, res)
                console.log(213213,cloneOption)
                initCharts(chartRef2, chartInstance2, cloneOption)
                break
            }

            default:
                break
        }
    }

    const getChartData3 = async () => {
        try {
            const [startTime,endTime] =  dateRangeArr[2]
            const params = {
                endTime: endTime?.valueOf()?.toString() || '',
                isPlReview: true,
                name: '',
                reviewType: EREVIEW_TYPE.TAB4,
                startTime: startTime?.valueOf()?.toString() || '',
            }

            const res = await getChart3DataApi(params)
            const cloneOption: any = cloneDeep(barChartOption)
            if (cloneOption && cloneOption.xAxis) {
                cloneOption.xAxis.data = res.workGroupName
            }
            cloneOption.series[0].data = res.number
            initCharts(chartRef3, chartInstance3, cloneOption)
        } catch (e: any) {
            const str = getErrorStr(e)
            dispatch(requestFail(str))
        }
    }

    const getChartData45 = async (reviewType: EREVIEW_TYPE) => {
        let params = {
            endTime: '',
            isPlReview: reviewType === EREVIEW_TYPE.TAB4 ? true : null,
            name: '',
            reviewType,
            startTime: '',
        }
        switch(reviewType){
            case EREVIEW_TYPE.TAB3:{
                const [startTime,endTime] = dateRangeArr[3]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                }
                break
            }
            case EREVIEW_TYPE.TAB4:{
                const [startTime,endTime] = dateRangeArr[4]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                }
                break
            }
        }
        try {
            const res = await getChart45DataApi(params)
            const cloneOption: any = cloneDeep(pieChartOption)
            cloneOption.series[0].data = res
            switch (reviewType) {
                case EREVIEW_TYPE.TAB3:
                    initCharts(chartRef4, chartInstance4, cloneOption)
                    break
                case EREVIEW_TYPE.TAB4:
                    initCharts(chartRef5, chartInstance5, cloneOption)
                    break
                default:
                    break
            }
        } catch (e: any) {
            const str = getErrorStr(e)
            dispatch(requestFail(str))
        }
    }

    const getChartData678 = async (type: ESTACKED_CHART_TYPE) => {
        let params:any = {
            endTime: '',
            isPlReview: true,
            name: '',
            reviewType: EREVIEW_TYPE.TAB4,
            startTime: '',
            type,
        }
        switch(type){
            case ESTACKED_CHART_TYPE.CHART6:{
                const [startTime,endTime] = dateRangeArr[5]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                    reviewType: EREVIEW_TYPE.TAB3,
                    isPlReview: null,
                }
                break
            }
            case ESTACKED_CHART_TYPE.CHART7:{
                const [startTime,endTime] = dateRangeArr[6]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                }
                break
            }
            case ESTACKED_CHART_TYPE.CHART8:{
                const [startTime,endTime] = dateRangeArr[7]
                params = {
                    ...params,
                    startTime:startTime?.valueOf()?.toString() || '',
                    endTime:endTime?.valueOf()?.toString() || '',
                }
                break
            }
        }
        const res = await getChart678DataApi(params)
        const yAxis: string[] = ['runningList', 'leadingList', 'advanceList']
        const keyMap: {
      [key: string]: string;
    } = {
        runningList: '追赶',
        leadingList: '领先',
        advanceList: '基础',
    }
        const cloneOption: any = cloneDeep(stackedBarChartOption)
        cloneOption.xAxis[0].data = res.orgNameList
        cloneOption.series = getSeriesData(yAxis, keyMap, res)
        switch (type) {
            case ESTACKED_CHART_TYPE.CHART6:
                initCharts(chartRef6, chartInstance6, cloneOption)
                break
            case ESTACKED_CHART_TYPE.CHART7:
                initCharts(chartRef7, chartInstance7, cloneOption)
                break
            case ESTACKED_CHART_TYPE.CHART8:
                initCharts(chartRef8, chartInstance8, cloneOption)
                break
            default:
                break
        }
    }

    // 新增 useEffect 初始化堆叠柱状图
    useEffect(() => {
    // 图1
        getChartData(EAPI_TYPE.TECH_TYPE)
        // 图2
        getChartData(EAPI_TYPE.LEAD)
        // 图3
        getChartData3()
        // 图4
        getChartData45(EREVIEW_TYPE.TAB3)
        // 图5
        getChartData45(EREVIEW_TYPE.TAB4)
        // 图6
        getChartData678(ESTACKED_CHART_TYPE.CHART6)
        // 图7
        getChartData678(ESTACKED_CHART_TYPE.CHART7)
        // 图8
        getChartData678(ESTACKED_CHART_TYPE.CHART8)
    }, [])

    const updateChart = (index:number) => {
        switch (index) {
            case 0:
                getChartData(EAPI_TYPE.TECH_TYPE)
                break
            case 1:
                getChartData(EAPI_TYPE.LEAD)
                break
            case 2:
                getChartData3()
                break
            case 3:
                getChartData45(EREVIEW_TYPE.TAB3)
                break
            case 4:
                getChartData45(EREVIEW_TYPE.TAB4)
                break
            case 5:
                getChartData678(ESTACKED_CHART_TYPE.CHART6)
                break
            case 6:
                getChartData678(ESTACKED_CHART_TYPE.CHART7)
                break
            case 7:
                getChartData678(ESTACKED_CHART_TYPE.CHART8)
                break
            default:
                break
        }
    }   

    const timePicker = (
        value: [EventValue<Moment>, EventValue<Moment>],
        index:number,
    ) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <RangePicker
                    style={{ width: 240 }}
                    picker="date"
                    format={DATE_FORMAT}
                    value={value}
                    onChange={(dates: RangeValue<Moment>)=>{
                        if(!dates) return
                        const temp = dateRangeArr.map((_,idx)=>{
                            if(index === idx){
                                return dates
                            } 
                            return _
                        })
                        setDateRangeArr(temp)
                        updateChart(index)
                    }}
                />
            </div>
        )
    }

    return (
        <>
            <Space direction="vertical" size={10} style={{ width: '100%' }}>
                <Nav dispatch={dispatch} />
                <PageBreadcrumb
                    routerParam={routes}
                    history={history}
                    dispatch={dispatch}
                />
                <Space style={{ width: '100%' }} direction="vertical">
                    <div style={{ margin:'0 25px 8px' }}>
                        {/* 添加比例选择器 */}
                        <Radio.Group 
                            value={aspectRatio}
                            onChange={e => setAspectRatio(e.target.value)}
                            style={{ marginBottom: 16 }}
                        >
                            <Radio.Button value="1:1">default</Radio.Button>
                            <Radio.Button value="16:9">16:9</Radio.Button>
                            <Radio.Button value="4:3">4:3</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div className="index_ls">
                        <Card className='chart_card' size="small" title={t('boardChart1')} extra={timePicker(dateRangeArr[0],0)}>
                            <div ref={chartRef1} style={getChartStyle(true)} />
                        </Card>
                    </div>
                    <div className="index_ls">
                        <Card className='chart_card' size="small" title={t('boardChart2')} extra={timePicker(dateRangeArr[1],1)}>
                            <div ref={chartRef2} style={getChartStyle(true)} />
                        </Card>
                    </div>
                    <div className="index_ls">
                        <Card className='chart_card' size="small" title={t('boardChart3')} extra={timePicker(dateRangeArr[2],2)}>
                            <div ref={chartRef3} style={getChartStyle(true)} />
                        </Card>
                    </div>
                    <div className="index_ls">
                        <Row>
                            <Col span={12}>
                                <Card size="small" title={t('boardChart4')} extra={timePicker(dateRangeArr[3],3)}>
                                    <div ref={chartRef4} style={{ height: 300 }} />
                                </Card>
                            </Col>
                            <Col span={12}>
                                <Card size="small" title={t('boardChart5')} extra={timePicker(dateRangeArr[4],4)}>
                                    <div ref={chartRef5} style={{ height: 300 }} />
                                </Card>
                            </Col>
                        </Row>
                    </div>
                    {/* <div className='index_ls'>
                    <Card size="small" title={t('boardChart6')}>
                        <ProposalTable />
                    </Card>
                </div> */}
                    <div className="index_ls">
                        <Card className='chart_card' size="small" title={t('boardChart7')} extra={timePicker(dateRangeArr[5],5)}>
                            <div ref={chartRef6} style={getChartStyle(false)} />
                        </Card>
                    </div>
                    <div className="index_ls">
                        <Card className='chart_card' size="small" title={t('boardChart8')} extra={timePicker(dateRangeArr[6],6)}>
                            <div ref={chartRef7} style={getChartStyle(false)} />
                        </Card>
                    </div>
                    <div className="index_ls">
                        <Card className='chart_card' size="small" title={t('boardChart9')} extra={timePicker(dateRangeArr[7],7)}>
                            <div ref={chartRef8} style={getChartStyle(false)} />
                        </Card>
                    </div>
                </Space>
            </Space>
        </>
    )
}
export default ProposalBoard
